module.exports = __webpack_public_path__ + "img/7_69.9716d89e.png";